// @flow
/** @jsx jsx */

import { Component } from 'react';
import { range } from 'lodash';

import { Button, Icon, Text } from '@zapier/common-components';
import { Colors, Zindexes } from '@zapier/theme';
import { css, jsx, keyframes } from '@emotion/core';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const containerStyles = css({
  position: 'fixed',
  zIndex: Zindexes.npsSurvey,
  border: `1px solid ${Colors.adamantium}`,
  bottom: '85px',
  right: '20px',
  padding: '15px',
  backgroundColor: Colors.white,
  borderRadius: '3px',
  textAlign: 'center',
  animation: `${fadeIn} 750ms`,
  boxShadow:
    '0 0 1px rgba(95, 108, 114, 0.08), 0 0px 6px rgba(95, 108, 114, 0.05)',
});

const labelStyles = css({
  maxWidth: '300px',
  margin: '0 auto 15px',
});

const buttonWrapperStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '15px',
});

const buttonLabelsStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
});

const circularButtonStyles = css({
  width: '32px',
  height: '32px',
  textAlign: 'center',
  margin: '5px',
  padding: '0',
  borderRadius: '50%',
  '&:hover': {
    color: Colors.white,
    background: Colors.deepSpace,
    borderColor: Colors.deepSpace,
  },
});

const dismissButtonWrapperStyles = css({
  position: 'absolute',
  top: '8px',
  right: '8px',
});

type Props = {
  onDismiss: () => void,
  onMount: () => void,
  onSubmit: (value: number) => void,
  onUnmount: () => void,
};

class NPSSurvey extends Component<Props> {
  componentDidMount() {
    this.props.onMount();
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  render() {
    return (
      <div css={containerStyles}>
        <div css={labelStyles}>
          <Text type="body-strong">
            How likely would you be to recommend Zapier to a friend or
            colleague?
          </Text>
        </div>

        <div>
          <div css={buttonWrapperStyles}>
            {range(1, 11).map(index => {
              return (
                <button
                  css={circularButtonStyles}
                  key={index}
                  onClick={() => this.props.onSubmit(index)}
                  type="button"
                  value={index}
                >
                  {index}
                </button>
              );
            })}
          </div>

          <div css={buttonLabelsStyles}>
            <span>Not likely</span>
            <span>Very likely</span>
          </div>

          <div css={dismissButtonWrapperStyles}>
            <Button
              backgroundType="chameleon"
              onClick={() => {
                this.props.onDismiss();
              }}
              size="small"
            >
              <Icon name="delete" size={10} />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default NPSSurvey;
